import { render, staticRenderFns } from "./df-page-promotions.vue?vue&type=template&id=7429a913"
import script from "./df-page-promotions.ts?vue&type=script&lang=js&external"
export * from "./df-page-promotions.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports